const alphabetBg = 'абвгдежзийклмнопрстуфхцчшщъьюя';
export const alphabetArray = Array.from(alphabetBg);
